import { trackPhotoLoadSuccess, trackPhotoDeleteSuccess, trackPhotoLoadError } from './tracking';

export const initializePhotoUploadTracking = ({
  controller,
  $rootScope,
  $timeout,
  $scope,
  trackingCategory,
  formIdService,
  config,
}) => {
  const { ad } = controller;
  const { deviceType } = config.get('adaptiveSettings') || {};

  controller.previousPhotoCount = ad.photos.length || 0;

  $rootScope.$on('cianUiPhotoUpload:PHOTOS_UPDATED', () => {
    $timeout(() => {
      const currentPhotoCount = ad.photos.length;

      if (currentPhotoCount > controller.previousPhotoCount) {
        const loadedPhotosCount = currentPhotoCount - controller.previousPhotoCount;

        for (let i = 0; i < loadedPhotosCount; i++) {
          trackPhotoLoadSuccess(trackingCategory, deviceType, formIdService.getId());
        }
      } else if (currentPhotoCount < controller.previousPhotoCount) {
        trackPhotoDeleteSuccess(trackingCategory, deviceType, formIdService.getId());
      }

      controller.previousPhotoCount = ad.photos.length;
    }, 0);
  });

  $scope.$watch(
    () => controller.photoErrors.length,
    (newErrorsCount, oldErrorsCount) => {
      if (newErrorsCount > oldErrorsCount) {
        controller.photoErrors.forEach(file => {
          if (!file.isAnalyticsSent) {
            trackPhotoLoadError(file.$error || file.$warning, trackingCategory, formIdService.getId());
          }

          file.isAnalyticsSent = true;
        });
      }
    },
  );
};
